var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"flex-center items-center mt-8"},[_c('Spinner',{staticClass:"opacity-50",attrs:{"size":6}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }